import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
  provideExperimentalZonelessChangeDetection,
} from '@angular/core';
import {
  provideClientHydration,
  withHttpTransferCacheOptions,
} from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideToastr } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';

import {
  CoreModule,
  storeInterceptor,
  authInterceptor,
  credentialsInterceptor,
  DataService,
  ConfigService,
  getAuthServiceConfigs,
} from '@speedy/core';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { provideServiceWorker } from '@angular/service-worker';

export function initializeDataService(dataService: DataService) {
  return () => dataService.initialize();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
    ),
    provideClientHydration(
      withHttpTransferCacheOptions({
        includePostRequests: true,
      }),
    ),
    provideAnimationsAsync(),
    provideHttpClient(
      withFetch(),
      withInterceptors([storeInterceptor, authInterceptor, credentialsInterceptor]),
    ),
    provideToastr({
      timeOut: 3000,
      preventDuplicates: true,
    }),
    importProvidersFrom([CoreModule.forRoot(environment), CookieService]),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeDataService,
      deps: [DataService],
      multi: true,
    },
    {
      provide: 'SocialAuthServiceConfig',
      useFactory: getAuthServiceConfigs,
      deps: [ConfigService],
    },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
